import { Button } from "@/app/components/shadcn/button";
import { X, Ticket } from "lucide-react";
import { AppliedDiscount } from "@/app/lib/features/cart/cart.types";

interface AppliedDiscountsProps {
  discounts: AppliedDiscount[];
  onRemove: () => void;
  isRemoving?: boolean;
}

const AppliedDiscounts = ({
  discounts,
  onRemove,
  isRemoving = false,
}: AppliedDiscountsProps) => {
  const coupons = discounts.filter((d) => d.type === "coupon");

  if (coupons.length === 0) return null;

  return (
    <div className="mb-4 space-y-2">
      {coupons.map((coupon, index) => {
        // API kuponun title'ını da code'unu da aynı değerle (kupon kodu)
        // gönderebiliyor; bu durumda kod üstte ve altta iki kez görünüyordu.
        // Anlamlı bir başlık yoksa üst satırda sabit etiket kullanılır.
        const heading =
          coupon.title && coupon.title !== coupon.code
            ? coupon.title
            : "Kupon İndirimi";

        return (
        <div
          key={index}
          className="flex items-center justify-between p-3 bg-green-50 border border-green-200 rounded-lg"
        >
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <Ticket className="w-4 h-4 text-green-600 shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-green-900 truncate">
                {heading}
              </p>
              {coupon.code && (
                <p className="text-xs text-green-700 truncate">{coupon.code}</p>
              )}
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <span className="text-sm font-semibold text-green-600">
              {coupon.amount_formatted}
            </span>
            <Button
              size="icon"
              variant="ghost"
              className="h-6 w-6 text-green-600 hover:text-red-600"
              onClick={onRemove}
              disabled={isRemoving}
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
        </div>
        );
      })}
    </div>
  );
};

export default AppliedDiscounts;